/**
 * After Paystack redirects back, the transaction reference is usually in `reference`
 * or `trxref`. We also embed `verify` on our callback URLs — Paystack may merge or
 * replace query params, so we accept all of these (fixes missing confirmation emails
 * when `verify` is dropped on mobile redirects).
 *
 * @param {URLSearchParams} searchParams
 * @returns {string}
 */
export function paystackReturnReference(searchParams) {
  if (!searchParams || typeof searchParams.get !== 'function') return '';
  const ref = searchParams.get('reference')?.trim()
    || searchParams.get('trxref')?.trim()
    || searchParams.get('verify')?.trim()
    || '';
  return ref;
}
